module.exports = __webpack_public_path__ + "static/media/leaf.fafdd11b.png";